// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z11C","option":"styles_option__1a8VV","active":"styles_active__2fL3W"};